import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@dbk-legacy/format';
import { View } from '@dbk/ui-react-utils';
import { Large } from '@dbk/ui-text';
import { EDELIVERY_CATEGORY_ID, EDELIVERY, SELECTED_RANGE, REPORT_PORTFOLIO_ID, REPORT_CATEGORY } from '../constants';

class ReportEmptyData extends PureComponent {


  getFormattedMessage = () => {
    // const { i18n: { messages }, reports: { selectedCategoryId, selectedReportDetailsDateRange } } = this.props;
    // let selectedCategoryName = this.getCategoryName(selectedCategoryId);
    // let duration = this.getDuration(selectedReportDetailsDateRange);

    const {
      reports: { selectedCategoryId, selectedReportDetailsDateRange,
        showUnreadOnlyChecked, user: { selectedPortfolioId } }
    } = this.props;
    let category = selectedCategoryId;
    if (showUnreadOnlyChecked) {
      category = EDELIVERY.UNREAD_CATEGORY_ID;
    }

    if (((selectedCategoryId === EDELIVERY_CATEGORY_ID.TAX_STATEMENTS.toString()) ||
      (selectedCategoryId === EDELIVERY_CATEGORY_ID.OTHER_DOCUMENTS.toString())) &&
      (selectedPortfolioId.id !== REPORT_PORTFOLIO_ID)) {
      return (<FormattedMessage
        id="app.chedelivery.reports.errorMssgeForNoPortfolio"
      />);
    }

    const selectedCategoryName = this.getCategoryName(category);
    const duration = this.getDuration(selectedReportDetailsDateRange);

    return (<FormattedMessage
      id="app.chedelivery.reports.emptymsg"
      values={{ selectedCategoryName, duration }}
    />);
  }

  /**
   * function: to get category name by selected category id
   */
  getCategoryName = (selectedCategoryId) => {
    const { i18n: { messages } } = this.props;
    let selectedCategoryName = "";
    const categoryId = parseInt(selectedCategoryId, 10);

    switch (categoryId) {
      case EDELIVERY.UNREAD_CATEGORY_ID:
        selectedCategoryName = messages['app.chedelivery.reports.unreadDocuments'];
        break;
      case EDELIVERY_CATEGORY_ID.PORTFOLIO_STATEMENTS:
        if(this.props.reports.selectedCategoryName === messages["app.chedelivery.reports.portfolioStatements"]) {
          selectedCategoryName = messages['app.chedelivery.reports.portfolioStatements'];
        } else if(this.props.reports.selectedCategoryName === messages["app.chedelivery.reports.category.allDocuments"]) {
          selectedCategoryName = messages['app.chedelivery.reports.edocumenttab'];
        }
        break;
      case EDELIVERY_CATEGORY_ID.ACCOUNT_STATEMENTS:
        selectedCategoryName = messages['app.chedelivery.reports.accountStatements'];
        break;
      case EDELIVERY_CATEGORY_ID.ADVICES:
        if(this.props.reports.selectedCategoryName === messages["app.chedelivery.reports.category.advices"] || this.props.reports.selectedCategoryName === messages['app.chedelivery.reports.advices']) {
          selectedCategoryName = messages['app.chedelivery.reports.advices'];
        } else if(this.props.reports.selectedCategoryName === messages["app.chedelivery.reports.category.corporateActions"]) {
          selectedCategoryName = messages['app.chedelivery.reports.corporateActionStatements'];
        }
        break;
      case EDELIVERY_CATEGORY_ID.TAX_STATEMENTS:
        selectedCategoryName = messages['app.chedelivery.reports.taxStatements'];
        break;
      case EDELIVERY_CATEGORY_ID.OTHER_DOCUMENTS:
        selectedCategoryName = messages['app.chedelivery.reports.otherDocuments'];
        break;
      case EDELIVERY_CATEGORY_ID.CONTRACTUAL_DOCUMENTS:
        selectedCategoryName = messages['app.chedelivery.reports.contractualDocuments'];
        break;
      case EDELIVERY_CATEGORY_ID.FROM_YOUR_ADVISOR:
        selectedCategoryName = messages['app.chedelivery.reports.receivedFromRM_category'];
        break;
      default:
        selectedCategoryName = messages['app.chedelivery.reports.unreadDocuments'];
        break;
    }
    return selectedCategoryName;
  }

  /**
   * function: to get duration on selection of Tabs
   */
  getDuration = (duration) => {
    const { i18n: { messages } } = this.props;
    let selectedDuration = "";
    switch (duration) {
      case SELECTED_RANGE.LAST_WEEK:
        selectedDuration = messages['app.chedelivery.reports.duration.lastweek'];
        break;
      case SELECTED_RANGE.LAST_MONTH:
        selectedDuration = messages['app.chedelivery.reports.duration.lastmonth'];
        break;
      case SELECTED_RANGE.LAST_90_DAYS:
        selectedDuration = messages['app.chedelivery.reports.duration.last90days'];
        break;
      case SELECTED_RANGE.CUSTOM:
        selectedDuration = messages['app.chedelivery.reports.duration.dateRange'];
        break;
      default:
        selectedDuration = messages['app.chedelivery.reports.duration.last90days'];
        break;
    }
    return selectedDuration;
  }

  render() {
    const { reports: { showSpinner } } = this.props;
    return (
      showSpinner === false &&  <div style={{ display:'table', width:'100%' }}>
        <Large
        tabIndex={0}
        className = "mssgeforNoDoc">
          {this.getFormattedMessage()}
        </Large>
      </div>
    );
  }
}

ReportEmptyData.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  reports: PropTypes.shape({
    user: { selectedPortfolioId: true },
    selectedCategoryId: PropTypes.string,
    selectedReportDetailsDateRange: PropTypes.string,

  })
}

ReportEmptyData.defaultProps = {
  i18n: {},
  reports: {}
};


export default createContainer(
  {
    $queries: {
      i18n: {
        messages: true,
      },
      reports: {
        showSpinner: true,
        user: { selectedPortfolioId: true },
        selectedReportDetailsDateRange: true,
        selectedCategoryId: true,
        showUnreadOnlyChecked: true,
        selectedCategoryName: true
      }
    },
  },

)(ReportEmptyData);
